import useGoBack from 'utilities/navigation/back'
import { FaFileSignature } from 'react-icons/fa6'
import { FaRectangleList } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa6'

const guids: string[] = [
    ' ۱- صدور پیش نویس در بخش سفته الکترونیک همیان.',
    '۲- دریافت گواهی امضا از اپلیکیشن امضامی.',
    '۳- بازگشت به همیان و ارسال سفته به امضامی در بخش امضای دیجیتال همیان.',
    '۴- مراجعه مجدد به امضامی و امضای سفته ارسال شده.',
    '۵- بازگشت به همیان و نهایی سازی سفته الکترونیک.',
]

export const SelectSignOrPromissory = () => {
    const goBack = useGoBack()

    return (
        <>
            <h1 className="text-md font-bold p-4 mb-2 w-full text-center bg-header-bg sticky top-0  text-green-1">
                سفته الکترونیک
            </h1>
            <div className="flex flex-col items-center mt-5 mx-4">
                <p className="text-justify leading-7 mb-5 p-3 shadow-sm border bg-green-2 rounded">
                    <span className="block">کاربر گرامی:</span>
                    برای صدور سفته مراحل زیر را به ترتیب تکمیل بفرمایید:
                    <p className="text-justify text-white leading-7 my-2 p-3 shadow-sm border bg-green-1 rounded">
                        {guids.map((guid, index) => (
                            <p key={index} className="block mb-1">
                                {guid}
                            </p>
                        ))}
                    </p>
                </p>
                <div className="w-full px-3">
                    <div className="flex flex-col items-center ">
                        <Link
                            to="/promissory/promissory-details"
                            className="w-full"
                        >
                            <div className="flex justify-around items-center bg-green-1 rounded-xl shadow">
                                <i
                                    className="flex items-center justify-around mr-1 bg-gray-4 rounded-full text-white text-xl p-3"
                                    style={{
                                        backgroundColor:
                                            'rgba(128, 128, 128, 0.4)',
                                    }}
                                >
                                    <FaRectangleList className="opacity-100" />
                                </i>
                                <div className="text-white text-center ml-3 p-2">
                                    <h1 className="text-xl my-2">
                                        سفته الکترونیک
                                    </h1>
                                    <small className="">
                                        صدور ضمانت سفته الکترونیک
                                    </small>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="flex flex-col items-center mt-4">
                        <Link to="/promissory/sign-details" className="w-full">
                            <div className="flex justify-around items-center bg-green-1 rounded-xl shadow">
                                <i
                                    className="flex items-center justify-center bg-gray-4 rounded-full text-white text-xl p-3"
                                    style={{
                                        backgroundColor:
                                            'rgba(128, 128, 128, 0.4)',
                                    }}
                                >
                                    <FaFileSignature className="opacity-100" />
                                </i>
                                <div className="text-white text-center ml-3 p-2">
                                    <h1 className="text-xl my-2">
                                        امضای دیجیتال
                                    </h1>
                                    <small className="">
                                        امضای دیجیتال در امضامی
                                    </small>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <button
                        className="rounded-full right-0 bottom-0 mt-4 p-3 text-center text-white text-xl bg-green-1"
                        onClick={goBack}
                    >
                        <FaArrowRight />
                    </button>
                </div>
            </div>
        </>
    )
}
